import React from 'react';

const Map: React.FC = () => {
  const comestAddress = "Co.Me.St. Costruz. Mecc. Stampaggio, Via Cristoforo Colombo, 5, 10070 Robassomero TO, Italia";
  const elpaAddress = "E.L.P.A. Solutions Srl, Via Cavour, 5/C, 10070 Zona Industriale di Robassomero TO, Italia";
  const mapUrl = `https://maps.google.com/maps?saddr=${encodeURIComponent(comestAddress)}&daddr=${encodeURIComponent(elpaAddress)}&t=&z=16&ie=UTF8&iwloc=A&dirflg=d&output=embed`;

  return (
    <section className="bg-gray-100 py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800">Le Nostre Sedi</h2>
          <div className="flex flex-col md:flex-row justify-center items-center mt-4 space-y-2 md:space-y-0 md:space-x-8 text-gray-600">
            <p><strong>CO.ME.ST:</strong> Via Cristoforo Colombo, 5, 10070 Robassomero TO</p>
            <p><strong>E.L.P.A. Solutions:</strong> Via Cavour, 5/C, 10070 Robassomero TO</p>
          </div>
        </div>
        <div className="relative h-96 rounded-lg shadow-xl overflow-hidden">
          <iframe
            title="Mappa delle nostre sedi"
            src={mapUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen={true}
            aria-hidden="false"
            tabIndex={0}
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Map; 